export default {"src":"/_next/static/media/realestate.e7f08641.svg","height":36,"width":36};